import { BottomNavigationAction, BottomNavigationActionProps } from "@mui/material";
import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";

export type NavigationButtonDefaultProps = Omit<BottomNavigationActionProps, "ref" | "children"> & {
  id: string | number;
  label: string | ReactNode;
  icon: JSX.Element;
  ref?: React.Ref<HTMLButtonElement>;
  path: string;
  // selected: boolean;
};

const NavigationButtonDefault: React.ForwardRefRenderFunction<
  HTMLButtonElement,
  NavigationButtonDefaultProps
> = ({ id, label, icon, ...rest }, ref) => {
  const { pathname } = useLocation();

  return (
    <BottomNavigationAction
      ref={ref}
      id={id}
      data-testid={id}
      label={label}
      icon={icon}
      className={
        "py-3 px-3 leading-4 flex justify-start items-center " +
        (pathname.startsWith(rest.path)
          ? " bg-ldir-blue-100 text-ldir-blue-900 font-bold"
          : "text-white")
      }
      sx={{
        "& .MuiBottomNavigationAction-label": {
          fontSize: "16px",
        },
      }}
      {...rest}
    />
  );
};

export default React.forwardRef(NavigationButtonDefault);
